import { gql, useMutation } from '@apollo/client';

import type { UpdateUserMutation, UpdateUserMutationVariables } from './__generated__/useUpdateUser.gql';

const UPDATE_USER = gql`
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      firstName
      lastName
      phoneNumber
      phoneNumberVerifiedAt
      preferredName
    }
  }
`;

export const useUpdateUser = () => {
  return useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UPDATE_USER, {
    refetchQueries: ['GetCallouts'],
  });
};
